/* eslint-disable react/prop-types */

import { motion } from "framer-motion";
import { IMAGE_URL } from "../../../constants";
import { Link } from "react-router-dom";

const ResourceCard = ({ title, description, image, link }) => {
  return (
    <Link to={link}>
      <motion.div
        className="bg-white rounded-xl shadow-lg px-6 py-12 flex flex-col items-center h-full text-center relative overflow-hidden"
        style={{
          "--primary-color": "#ED1C2E",
        }}
        whileHover={{ y: -5 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <motion.div
          className="absolute inset-0 bg-gradient-to-br from-blue-50 to-purple-50 opacity-0"
          whileHover={{ opacity: 1 }}
        />
        <motion.div
          className="absolute inset-0 rounded-xl pointer-events-none"
          style={{
            maskImage:
              "linear-gradient(to right, black 2px, transparent 2px), linear-gradient(to bottom, black 2px, transparent 2px), linear-gradient(to left, black 2px, transparent 2px), linear-gradient(to top, black 2px, transparent 2px)",
            maskComposite: "intersect",
            WebkitMaskComposite: "source-in",
            maskSize: "100% 100%",
          }}
        />
        <motion.div
          className="relative z-10 w-auto h-8 mb-8"
          whileHover={{ scale: 1.1 }}
        >
          <img
            src={`${IMAGE_URL}/${image}`}
            alt={`${title} logo`}
            // layout="fill"
            // objectFit="cover"
            className="w-full h-full"
          />
        </motion.div>
        <h3 className="relative z-10 text-xl font-bold mb-2 text-gray-800">
          {title}
        </h3>
        <p className="relative z-10 line-clamp-4 text-gray-600">
          {description}
        </p>
      </motion.div>
    </Link>
  );
};

export default ResourceCard;
